import { getLowerPrice } from './formula';

export const renderRowValue = (t, itemColumn, itemRow) => {
    let rowValue = null;
    let duoRowValue = null;
    let trioRowValue = null;
    const fields = itemColumn?.field?.split('.') ?? [];
    const duoFields = itemColumn?.duoField?.split('.') ?? [];
    const trioFields = itemColumn?.trioField?.split('.') ?? [];

    for (const field of fields) {
        // テーブルではedlpと更徳を比較して安い金額を表示
        if (field === 'discountedEdlpSellingPrice') {
            const edlpPrice = !rowValue ? itemRow[field ?? ''] : rowValue[field];
            const saratokuPrice = !rowValue ? itemRow['discountedSaratokuSellingPrice'] : rowValue['discountedSaratokuSellingPrice'];
            rowValue = getLowerPrice(edlpPrice, saratokuPrice);
        } else {
            rowValue = !rowValue ? itemRow[field ?? ''] : rowValue[field];
        }
    }

    for (const field of duoFields) {
        // テーブルではedlpと更徳を比較して安い金額を表示
        if (field === 'edlpSellingPrice') {
            const edlpPrice = !duoRowValue ? itemRow[field ?? ''] : duoRowValue[field];
            const saratokuPrice = !duoRowValue ? itemRow['saratokuSellingPrice'] : duoRowValue['saratokuSellingPrice'];
            duoRowValue = getLowerPrice(edlpPrice, saratokuPrice);
        } else {
            duoRowValue = !duoRowValue ? itemRow[field ?? ''] : duoRowValue[field];
        }
    }

    for (const field of trioFields) {
        trioRowValue = !trioRowValue ? itemRow[field ?? ''] : trioRowValue[field];
    }

    // PB・留型
    if (itemColumn?.field === 'nbpbkbn') {
        rowValue = getNbpbkbnLabel(t, rowValue);
    }
    // 登録許可
    if (itemColumn?.field === 'allowChangeRequestWithoutValidation') {
        rowValue = rowValue ? '〇' : '-';
    }
    // tax表示
    if (itemColumn?.field === 'tax') {
        rowValue = itemColumn?.value === 'included' ? '税込み' : '税抜き';
    }
    // 値入率
    if (itemColumn?.field === 'markupRate') {
        rowValue = rowValue !== null ? rowValue + '%' : '-';
    }

    const isDiscounted = itemRow?.discountedCategory === '2' || rowValue !== duoRowValue;

    if (!rowValue) {
        return '-';
    }

    // 通常
    if (!duoRowValue) {
        return itemColumn?.mappingData ? (itemColumn.mappingData.find((item) => item.value === rowValue)?.label ?? rowValue) : rowValue;
    }

    // ユニット単価表示
    if (!!trioRowValue) {
        return (
            <>
                {rowValue}円 / {duoRowValue}
                {trioRowValue}
            </>
        );
    }

    // 赤文字二段
    if (itemColumn?.colorRed) {
        return (
            <>
                <strong className="color-red">{rowValue}</strong>
                {isDiscounted && (
                    <>
                        <br />
                        {duoRowValue}
                    </>
                )}
            </>
        );
    }

    // 容量表示
    if (!!itemColumn?.unit) {
        return (
            <>
                {rowValue}
                {duoRowValue}
            </>
        );
    }

    // 太文字二段
    return (
        <>
            <strong>{rowValue}</strong>
            {isDiscounted && (
                <>
                    <br />
                    {duoRowValue}
                </>
            )}
        </>
    );
};

export function getNbpbkbnLabel(t, rowValue) {
    switch (rowValue) {
        case 0:
        case 1:
            return '-';
        case 2:
            return t('table.pb');
        case 3:
            return t('table.retained_type');
        default:
            return '-';
    }
}

/**
 * HTから入力された入力者名をを携帯端末と表示
 * - HTから入力された場合、「12345678」(今後解消予定)
 *
 * @param {string} requesterName
 * @returns {string} 入力者名
 */
export function formatHtRequesterName(requesterName) {
    return requesterName === '12345678' ? '携帯端末' : requesterName;
}
